
import { AmericanoPlayer, AmericanoMatch } from './types';

// Improved Americano partnership generation with rotation
export const generateAmericanoPartnerships = (playerList: AmericanoPlayer[], round: number) => {
  const players = [...playerList];
  const partnerships: Array<{ player1: AmericanoPlayer; player2: AmericanoPlayer }> = [];
  
  // Advanced rotation algorithm to ensure varied partnerships
  const rotation = ((round - 1) * Math.floor(players.length / 2)) % players.length;
  
  // Rotate the player list based on the round
  for (let i = 0; i < rotation; i++) {
    const player = players.shift();
    if (player) players.push(player);
  }

  // Create partnerships
  for (let i = 0; i < players.length; i += 2) {
    if (players[i] && players[i + 1]) {
      partnerships.push({
        player1: players[i],
        player2: players[i + 1]
      });
    }
  }

  return partnerships;
};

// Improved court assignment based on combined rankings
export const assignAmericanoCourts = (partnerships: Array<{ player1: AmericanoPlayer; player2: AmericanoPlayer }>) => {
  const rankedPartnerships = partnerships
    .map(pair => ({
      ...pair,
      combinedPoints: pair.player1.points + pair.player2.points,
      averagePoints: (pair.player1.points + pair.player2.points) / 2
    }))
    .sort((a, b) => b.combinedPoints - a.combinedPoints);

  const newMatches: AmericanoMatch[] = [];
  for (let i = 0; i < rankedPartnerships.length; i += 2) {
    if (rankedPartnerships[i + 1]) {
      newMatches.push({
        court: Math.floor(i / 2) + 1,
        team1: {
          player1: rankedPartnerships[i].player1,
          player2: rankedPartnerships[i].player2
        },
        team2: {
          player1: rankedPartnerships[i + 1].player1,
          player2: rankedPartnerships[i + 1].player2
        }
      });
    }
  }

  return newMatches;
};
